import {Dropdown} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import Noprofile from "../../../images/avatarAdmin.png";
import {useNotifications} from "../../../hooks/useNotification";
import Loader from "../../components/shared/Loader";
import {Navigate, useNavigate} from "react-router-dom";
import ImageComponent from "../../components/shared/ImageComponent";
import {proposalDate} from "../../../utils/date";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {useTickets} from "../../../hooks/useTicket";
import {ticketStatus} from "../../../utils/constants";
import {getTicketStatusColor, ticketStatusOptions} from "../../../utils/status";
import TicketCard from "./ticketCard";
import {useState} from "react";
import AddTicketModal from "./AddTicketModal";
import QueryErrorState from "../../components/shared/QueryErrorState";
import EmptyState from "../../components/shared/EmptyState";

const TicketsPage = ({user}) => {
  const {data, isError, isLoading, error, refetch} = useTickets(user);
  const [ticketModal, setTicketModal] = useState(false);
  const navigate = useNavigate();
  if (isLoading) {
    return <Loader className="relative" />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }

  const navigateToChat = (notification) => {
    if (notification?.notifiableType === "offer") {
      // navigate(`/annonce/${notification?.notifiableId}`);
      navigate(`/`);
    } else if (!!notification?.chatroomId) {
      navigate("/messages#" + notification?.chatroomId);
    }
    return;
  };

  return (
    <>
      <AddTicketModal openModal={ticketModal} toggleModal={setTicketModal} />
      <div className="w-full gap-4 flex flex-col justify-start items-start  ">
        <div className="text-[#19295C] font-bold text-base sm:text-lg 2xl:text-xl w-full flex items-center justify-between gap-2">
          Liste des réclamations
          <button
            onClick={() => {
              setTicketModal(true);
            }}
            className="bg-[#ff6600] text-white rounded-md text-xs text-nowrap font-medium px-3 py-2 "
          >
            Soumettre une réclamation
          </button>
        </div>

        {!data?.length ? (
          <EmptyState className="w-full bg-white h-[70vh] py-3 rounded-2xl" />
        ) : (
          <div className="w-full flex flex-col gap-3 justify-start items-start">
            {data?.map((ticket) => (
              <TicketCard ticket={ticket} key={ticket?.id} />
            ))}
          </div>
        )}
      </div>
      {/* <div className="card !w-full ">
        <div className="card-header  border-0 pb-0">
          <div className="card-title !text-[#19295C] !font-bold !text-base w-full text-left sm:!text-lg 2xl:!text-xl">
            Réclamations
          </div>
        </div>

        <div className="card-body">
          {!data?.length ? (
            <div className="text-base text-[#7e7e7e]">Pas de Réclamations</div>
          ) : (
            <PerfectScrollbar
              options={{suppressScrollX: true}}
              style={{height: "70vh", overflowX: "hidden"}}
              id="DZ_W_Todo1"
              className="widget-media dz-scroll ps ps--active-y h-fit max-h-[70vh] "
            >
              <ul className="timeline">
                {data?.map((ticket) => (
                  <li
                    className="cursor-pointer"
                    onClick={() => navigateToChat(ticket)}
                  >
                    <div className="timeline-panel">
                      <div className="media mr-2">
                        <ImageComponent
                          alt={"avatar"}
                          className={"!rounded-full"}
                          src={buildImageUrl(ticket?.User?.imageUri)}
                          fallback={
                            <img
                              alt=""
                              className="!rounded-full"
                              src={Noprofile}
                            />
                          }
                        />
                      </div>
                      <div className="media-body">
                        <h5 className="mb-1 text-sm sm:text-base">
                          {!!ticket?.User
                            ? `Discussion avec ${ticket?.User?.firstName} ${ticket?.User?.lastName}`
                            : `Nouvelle Réclamation`}
                        </h5>
                        <small className="d-block">
                          {proposalDate(ticket?.updatedAt)}
                        </small>
                      </div>
                      <div
                        className="text-xs font-medium text-nowrap p-2 rounded-full"
                        style={{
                          backgroundColor: getTicketStatusColor({
                            status: ticket?.status,
                          }).bg,
                          color: getTicketStatusColor({status: ticket?.status})
                            .color,
                        }}
                      >
                        {
                          ticketStatusOptions.find(
                            (tick) => tick.value === ticket?.status
                          ).label
                        }
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </PerfectScrollbar>
            
          )}
        </div>
      </div> */}
    </>
  );
};

export default TicketsPage;
